import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/CampaignDetails.css';
import { useAuth } from '../contexts/AuthContext';
import SideDrawer from '../components/SideDrawer';
import FollowersSvg from '../assets/icons/couple-family-icon.svg';
import LikeSvg from '../assets/icons/red-heart-icon.svg';
import CommentsSvg from '../assets/icons/positive-feedback-icon.svg';
import ViewsSvg from '../assets/icons/eye-icon.svg';
import { Card, CardBody, Button, Row, Col, Form } from 'react-bootstrap';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import { getInfluencersByCampaignID, getInfluencers, getPostDataByCampaignId } from '../services/api';
import InstagramSvg from '../assets/icons/instagram.svg';
import TikTokSvg from '../assets/icons/tiktok-icon.svg';
import {
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBListGroup,
    MDBListGroupItem,
    MDBInputGroup,
    MDBInput,
    MDBCheckbox,
    MDBDropdownItem
} from "mdb-react-ui-kit";
import { formatPostDate } from '../services/dateFormate';

const MonetaryMetricData = [
    { value: '$0.07', label: 'Cost per engagement (CPE)' },
    { value: '$2.89', label: 'Cost per mille (CPM)' },
    { value: '$0.00', label: 'Cost per view (CPV)' },
    { value: '$3.04M', label: 'Total media value (TMV)' },
];

// const postsData = [
//     { url: 'https://www.youtube.com/embed/71xacArT_70', title: 'Top 10 RAREST PRIME...', date: 'Jul 13, 2023 at 05:17 AM', likes: '3.13K', comments: '360', views: '473.63K', engagement: '0.09%' },
//     { url: 'https://www.youtube.com/embed/abc', title: 'rowdyrogfam', date: 'Jul 01, 2023 at 01:27 AM', likes: '50.8K', comments: '377', views: '1.7M', engagement: '3.67%' },
//     { url: 'https://www.youtube.com/embed/abc', title: 'rowdyrogfam', date: 'Jul 01, 2023 at 01:27 AM', likes: '50.8K', comments: '377', views: '1.7M', engagement: '3.67%' },
// ];

const Metric = ({ icon, value, label, subLabel }) => (
    <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "4px",
        padding: "10px",
        minWidth: "200px"
    }}>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {icon && <img src={icon} alt={label} style={{ width: "18px", height: "18px" }} />}
            <strong style={{ fontSize: "20px" }}>{value}</strong>
        </div>
        <div style={{ fontSize: "14px", color: "#555" }}>{label}</div>
        {subLabel && <div style={{ fontSize: "14px", color: "#888" }}>{subLabel}</div>}
    </div>
);

const CampaignDetails = () => {
    const location = useLocation();
    const { isCollapsed } = useAuth();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('Social');
    const campaignData = location.state?.campaignData || {};
    const [campaignInfluencerList, setCampaignInfluencerList] = useState([]);
    const [selectedInfluencers, setSelectedInfluencers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedPlatforms, setSelectedPlatforms] = useState([]);

    // Platform Data
    const platformOptions = [
        { id: "9bb8913b-ddd9-430b-a66a-d74d846e6c66", name: "Instagram", icon: InstagramSvg },
        { id: "de55aeec-0dc8-4119-bf90-16b3d1f0c987", name: "TikTok", icon: TikTokSvg },
    ];

    const [postType, setPostType] = useState([]);
    const [campaignPostData, setCampaignPostData] = useState([]);

    const fetchData = useCallback(async () => {
        try {
            console.log("Fetching data with:", selectedPlatforms, selectedInfluencers);

            const response = await getPostDataByCampaignId(
                campaignData.campaignID,
                selectedPlatforms,
                selectedInfluencers
            );

            // Ensure we extract the `data` property
            if (response?.data && Array.isArray(response.data)) {
                setCampaignPostData(response.data);
            } else {
                console.warn("Unexpected API response format:", response);
                setCampaignPostData([]);
            }
        } catch (error) {
            console.error("Error fetching influencers data:", error);
            setCampaignPostData([]);
        }
    }, [campaignData.campaignID, selectedPlatforms, selectedInfluencers]);

    useEffect(() => {
        fetchData();
        console.log("Test ", campaignPostData);
    }, [fetchData]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch influencer IDs associated with the campaign
                const influencerIDs = await getInfluencersByCampaignID(campaignData.campaignID,);
                const params = new URLSearchParams();
                influencerIDs.data.forEach((id) => params.append('influencerIds', id.influencerID));

                // Fetch detailed information about the influencers
                const { data } = await getInfluencers(params);
                setCampaignInfluencerList(data);
            } catch (error) {
                console.error('Error fetching influencers data:', error);
            }
        };

        fetchData();
    }, [campaignData.campaignID]);

    const handleCampaignAnalysisClick = (post) => {
        navigate('/campaignAnalysis', { state: { postData: post } });
    };

    const formatDateString = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', options);
    };

    const formatFollowers = useCallback((count) => {
        const formats = [
            { threshold: 1e9, suffix: 'B' },
            { threshold: 1e6, suffix: 'M' },
            { threshold: 1e3, suffix: 'K' },
        ];

        const format = formats.find((f) => count >= f.threshold);
        if (!format) return count?.toString();

        return (count / format.threshold).toFixed(1).replace(/\.0$/, '') + format.suffix;
    }, []);

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    // const handleSelect = (influencerID) => {
    //     setSelectedInfluencers(prevState =>
    //         prevState.includes(influencerID)
    //             ? prevState.filter(id => id !== influencerID)
    //             : [...prevState, influencerID]
    //     );
    // };
    const handleSelect = (influencerID) => {
        setSelectedInfluencers((prevState) => {
            if (prevState.includes(influencerID)) {
                return prevState.filter((id) => id !== influencerID); // Remove from selection
            } else {
                return [...prevState, influencerID]; // Add to selection
            }
        });
    };
    

    // Toggle platform selection
    const togglePlatform = (platformId) => {
        setSelectedPlatforms((prev) =>
            prev.includes(platformId) ? prev.filter((id) => id !== platformId) : [...prev, platformId]
        );
    };

    const filteredInfluencers = campaignInfluencerList.filter(influencer =>
        influencer.creatorName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const selectPostType = (type) => {
        setPostType(prev => prev.includes(type) ? prev.filter(p => p !== type) : [...prev, type]);
    };

    function formatNumber(value) {

        if (value >= 1e9) {
            return (value / 1e9).toFixed(2) + "B";
        } else if (value >= 1e6) {
            return (value / 1e6).toFixed(2) + "M";
        } else if (value >= 1e3) {
            return (value / 1e3).toFixed(2) + "K";
        } else {
            return value?.toString();
        }
    }

    function calculateEngagementRate(postData) {
        if (!postData || !postData.engagement) return "0%"; // Handle missing data

        const totalEngagement =
            (postData.engagement.like_count ?? 0) +
            (postData.engagement.comment_count ?? 0) +
            (postData.share_count ?? 0);

        return postData.totalViews
            ? ((totalEngagement / postData.totalViews) * 100).toFixed(2) + "%"
            : "0%";
    }

    function calculateMetrics(data) {
        if (!data || !data || data.length === 0) {
            console.log("No data available.");
            return;
        }

        let totalLikes = 0, totalComments = 0, totalViews = 0, totalShares = 0, totalEngagement = 0, totalImpressions = 0;
        let postCount = data.length;

        data.forEach(post => {
            const engagement = post.engagement || {};

            // Extracting values with null checks
            const likeCount = engagement.like_count ?? 0;
            const commentCount = engagement.comment_count ?? 0;
            const viewCount = engagement.view_count ?? 0;
            const shareCount = engagement.share_count ?? 0; // Assuming null means 0
            const impressions = post.impressions ?? viewCount; // Assuming impressions are same as views if not provided

            // Total Engagement = Likes + Comments + Shares
            const postEngagement = likeCount + commentCount + shareCount;

            // Summing up for overall calculations
            totalLikes += likeCount;
            totalComments += commentCount;
            totalViews += viewCount;
            totalShares += shareCount;
            totalEngagement += postEngagement;
            totalImpressions += impressions;
        });

        // **Calculating Averages**
        const avgLikes = (totalLikes / postCount).toFixed(1);
        const avgComments = (totalComments / postCount).toFixed(1);
        const avgViews = (totalViews / postCount).toFixed(2);
        const avgShares = (totalShares / postCount).toFixed(1);
        const avgEngagements = (totalEngagement / postCount).toFixed(1);
        const avgImpressions = (totalImpressions / postCount).toFixed(2);

        // **Engagement Rate Calculation** = (Total Engagement / Total Views) * 100
        const engagementRate = totalViews > 0 ? ((totalEngagement / totalViews) * 100).toFixed(2) : 0;

        // **Displaying Metrics**
        console.log("📊 Social Media Metrics Summary:");
        console.log("Total Likes:", totalLikes, "| Avg Likes per Post:", avgLikes);
        console.log("Total Comments:", totalComments, "| Avg Comments per Post:", avgComments);
        console.log("Total Views:", totalViews, "| Avg Views per Post:", avgViews);
        console.log("Total Shares:", totalShares, "| Avg Shares per Post:", avgShares);
        console.log("Total Engagement:", totalEngagement, "| Avg Engagements per Post:", avgEngagements);
        console.log("Total Impressions:", totalImpressions, "| Avg Impressions per Post:", avgImpressions);
        console.log("📈 Engagement Rate:", engagementRate + "%");

        return {
            totalLikes, avgLikes,
            totalComments, avgComments,
            totalViews, avgViews,
            totalShares, avgShares,
            totalEngagement, avgEngagements,
            totalImpressions, avgImpressions,
            engagementRate
        };
    }

    const handleBackClick = () => {
      // Navigate back or to a specific route
      navigate(-1);
    };


    return (
        <div className="App">
            <SideDrawer />
            <div className="main-container" style={{ marginLeft: isCollapsed ? '6%' : '13.6%' }}>
                <main className="content">
                <section className="campaign-header d-flex align-items-center">
                    {/* Back arrow button */}
                    <div className="me-3" style={{ cursor: 'pointer' }} onClick={handleBackClick}>
                        <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#000"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        >
                        <line x1="20" y1="12" x2="4" y2="12" />
                        <polyline points="10 18 4 12 10 6" />
                        </svg>
                    </div>

                    {/* Existing logo/graphic */}
                    <div className="me-3">
                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="40" cy="40" r="40" fill="white" fillOpacity="0.7"></circle>
                        <path
                            d="M33.0769 48.5263C33.0769 48.5263 46 50.4211 51.5385 56.1053H53.3846C54.4042 56.1053 55.2308 55.257 55.2308 54.2105V42.7227C56.8233 42.3021 58 40.8183 58 39.0526C58 37.2869 56.8233 35.8032 55.2308 35.3825V23.8947C55.2308 22.8483 54.4042 22 53.3846 22H51.5385C46 27.6842 33.0769 29.5789 33.0769 29.5789H25.6923C23.6531 29.5789 22 31.2756 22 33.3684V44.7368C22 46.8298 23.6531 48.5263 25.6923 48.5263H27.5385L29.3846 58H33.0769V48.5263ZM36.7692 32.7265C38.0307 32.4487 39.5892 32.0647 41.2726 31.5565C44.3708 30.6213 48.3077 29.1481 51.5385 26.8782V51.2271C48.3077 48.9572 44.3708 47.484 41.2726 46.5488C39.5892 46.0406 38.0307 45.6565 36.7692 45.3788V32.7265ZM25.6923 33.3684H33.0769V44.7368H25.6923V33.3684Z"
                            fill="#014550"
                        ></path>
                        </svg>
                    </div>

                    {/* Campaign title and info */}
                    <div>
                        <h1>{campaignData.name}</h1>
                        <p>
                        USD {formatFollowers(campaignData.budget)} | {formatDateString(campaignData.startDate)} - {formatDateString(campaignData.endDate)} |{' '}
                        {campaignInfluencerList.length} creator accounts
                        </p>
                    </div>
                    </section>

                    <Row className="filters">
                        <Col md={2} className="mb-2 camp-dropdown-wrapper">
                            <MDBDropdown>
                                <MDBDropdownToggle>
                                    {selectedPlatforms.length > 0
                                        ? platformOptions
                                            .filter(({ id }) => selectedPlatforms.includes(id))
                                            .map(({ icon, name }) => (
                                                <img key={name} src={icon} width={20} height={20} alt={`${name} Icon`} className="me-1" />
                                            ))
                                        : "Select Platforms"}
                                </MDBDropdownToggle>
                                <MDBDropdownMenu>
                                    {platformOptions.map(({ id, name, icon }) => (
                                        <MDBDropdownItem key={id}>
                                            <MDBCheckbox
                                                label={
                                                    <>
                                                        <img src={icon} width={20} height={20} alt={`${name} Icon`} /> {name}
                                                    </>
                                                }
                                                checked={selectedPlatforms.includes(id)}
                                                onChange={() => togglePlatform(id)}
                                            />
                                        </MDBDropdownItem>
                                    ))}
                                </MDBDropdownMenu>
                            </MDBDropdown>
                        </Col>
                        {/* <Col md={2} className="mb-2 camp-dropdown-wrapper">
                            <MDBDropdown>
                                <MDBDropdownToggle>Post Types</MDBDropdownToggle>
                                <MDBDropdownMenu>
                                    <MDBDropdownItem><MDBCheckbox label="Video" checked={postType} onChange={() => selectPostType('Video')} /></MDBDropdownItem>
                                    <MDBDropdownItem><MDBCheckbox label="Image" checked={postType} onChange={() => selectPostType('Image')} /></MDBDropdownItem>
                                </MDBDropdownMenu>
                            </MDBDropdown>
                        </Col> */}
                        <Col md={4} className="mb-2 camp-dropdown-wrapper">
                            <MDBDropdown className="w-100">
                                <MDBDropdownToggle>Select Creator Accounts</MDBDropdownToggle>
                                <MDBDropdownMenu className="w-100 p-2" style={{ maxHeight: "300px", overflowY: "auto" }}>

                                    {/* Search Bar */}
                                    <MDBInputGroup className="mb-2">
                                        <MDBInput label="Enter username or handle" value={searchTerm} onChange={handleSearch} />
                                    </MDBInputGroup>

                                    {/* Influencer List */}
                                    {/* Influencer List */}
                                    <MDBListGroup>
                                        {filteredInfluencers.map((influencer) => (
                                            <MDBListGroupItem
                                                key={influencer.influencerId}
                                                className="d-flex align-items-center"
                                                active={selectedInfluencers.includes(influencer.influencerId)}
                                                style={{ cursor: "pointer", borderBottom: "1px solid #ddd" }}
                                            >
                                                <MDBCheckbox
                                                    checked={selectedInfluencers.includes(influencer.influencerId)} // ✅ Now correctly reflects the selection state
                                                    onChange={() => handleSelect(influencer.influencerId)}
                                                    label=""
                                                    className="me-3"
                                                />
                                                <img
                                                    src={influencer.profileImg || "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-profiles/avatar-2.webp"}
                                                    alt="profile"
                                                    style={{ width: "40px", height: "40px" }}
                                                    className="rounded-circle me-2"
                                                />
                                                <div>
                                                    <p className="fw-bold mb-0">{influencer.creatorName}</p>
                                                    <small className="text-muted">{influencer.email}</small>
                                                </div>
                                            </MDBListGroupItem>
                                        ))}
                                    </MDBListGroup>


                                </MDBDropdownMenu>
                            </MDBDropdown>
                        </Col>
                    </Row>

                    <Card className="performance-metrics mt-4">
                        <CardBody>
                            <div className="heading mb-5">
                                <h4>Performance</h4>
                            </div>
                            <div className="metrics-header d-flex justify-content-start">
                                {/* {['Social', 'Monetary', 'Comments'].map((tab) => ( */}
                                {['Social'].map((tab) => (
                                    <Button
                                        key={tab}
                                        variant={activeTab === tab ? 'primary' : 'outline-primary'}
                                        className="me-2 "
                                        onClick={() => setActiveTab(tab)}
                                    >
                                        {tab}
                                    </Button>
                                ))}
                            </div>
                            {activeTab === 'Social' && (
                                <Card>
                                    <Card.Body>
                                        <div style={{
                                            display: "grid",
                                            gridTemplateColumns: "repeat(3, 1fr)", // 3 per row
                                            gap: "20px",
                                            padding: "20px"
                                        }}>
                                            {(() => {
                                                const socialMetricsData = calculateMetrics(campaignPostData) || {};
                                                const metrics = [
                                                    { key: "totalLikes", icon: LikeSvg, value: formatNumber(socialMetricsData.totalLikes), label: "Total Likes", subLabel: formatNumber(socialMetricsData?.avgLikes) + " average likes per post" },
                                                    { key: "totalComments", icon: CommentsSvg, value: formatNumber(socialMetricsData.totalComments), label: "Total Comments", subLabel: formatNumber(socialMetricsData?.avgComments) + " average comments per post" },
                                                    { key: "totalViews", icon: ViewsSvg, value: formatNumber(socialMetricsData.totalViews), label: "Total Views", subLabel: formatNumber(socialMetricsData?.avgViews) + " average views per post" },
                                                    { key: "totalShares", icon: FollowersSvg, value: formatNumber(socialMetricsData.totalShares), label: "Total Shares on TikTok", subLabel: formatNumber(socialMetricsData?.avgShares) + " average shares per post" },
                                                    { key: "totalEngagement", value: formatNumber(socialMetricsData.totalEngagement), label: "Total Engagement", subLabel: formatNumber(socialMetricsData?.avgEngagements) + " average engagements per post" },
                                                    { key: "totalImpressions", value: formatNumber(socialMetricsData.totalImpressions), label: "Total Impressions", subLabel: formatNumber(socialMetricsData?.avgImpressions) + " average impressions per post" },
                                                    { key: "engagementRate", value: socialMetricsData.engagementRate, label: "Engagement Rate" }
                                                ];

                                                return metrics.map(({ key, icon, value, label, subLabel }) => (
                                                    <Metric key={key} icon={icon} value={value} label={label} subLabel={subLabel} />
                                                ));
                                            })()}
                                        </div>
                                    </Card.Body>
                                </Card>
                            )}

                            {activeTab === 'Monetary' && (
                                <Card>
                                    <Card.Body>
                                        <div className="metrics-grid">
                                            {MonetaryMetricData.map((metric, idx) => (
                                                <Metric key={idx} {...metric} />
                                            ))}
                                        </div>
                                    </Card.Body>
                                </Card>
                            )}
                            {activeTab === 'Comments' && (
                                <div className="">
                                    <Card className="p-4 w-100">
                                        <Card.Body>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <p>780 comments analyzed. This doesn’t include replies to the comments.</p>
                                                <Button variant="outline-secondary" size="sm">
                                                    Learn how we calculate this with AI
                                                </Button>
                                            </div>
                                            <hr />
                                            <div className="d-flex justify-content-between mt-5">
                                                <div>
                                                    <h5 className="fw-bold">23.10%</h5>
                                                    <p className="mb-0">Relevant Comments</p>
                                                    <hr className="my-1 p-0"></hr>
                                                    <small>180 total relevant comments</small>
                                                </div>
                                                <div>
                                                    <h5 className="fw-bold">34.40%</h5>
                                                    <p className="mb-0">Positive Audience Sentiment</p>
                                                    <hr className="my-1 p-0"></hr>
                                                    <small>268 total positive comments</small>
                                                </div>
                                                <div>
                                                    <h5 className="fw-bold">8.30%</h5>
                                                    <p className="mb-0">Purchase Intent</p>
                                                    <hr className="my-1 p-0"></hr>
                                                    <small>65 comments showed purchase intent</small>
                                                </div>
                                            </div>
                                        </Card.Body>
                                        <Card.Footer className="bg-warning text-dark d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <span>
                                                    3/3 social accounts for your brand are missing. Add them now to get the complete picture across all platforms.
                                                </span>
                                            </div>
                                            <Button variant="outline-dark" size="sm">
                                                Add brand accounts
                                            </Button>
                                        </Card.Footer>
                                    </Card>
                                </div>
                            )}
                        </CardBody>
                    </Card>

                    <MDBTable striped hover className="posts-table mt-4">
                        <MDBTableHead>
                            <tr>
                                <th>Posted On</th>
                                <th>Likes</th>
                                <th>Comments</th>
                                <th>Views</th>
                                <th>Engagement Rate</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            {campaignPostData.map((post, idx) => (
                                <tr key={idx}>
                                    <td>
                                        <div className="post-container" onClick={() => handleCampaignAnalysisClick(post)}>
                                            {/* <div className="post-container"> */}
                                            <iframe
                                                className="post-video"
                                                src={post.media_url}
                                                title={post.title || "Post Video"}
                                                frameBorder="0"
                                                allowFullScreen
                                            ></iframe>
                                            <div className="post-details">
                                                <span className="post-title">{post.title || ""}</span>
                                                <span>{post.published_at ? formatPostDate(new Date(post.published_at).toLocaleDateString()) : "No Date"}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td><img src={LikeSvg} style={{ width: '18px', height: '18px', marginRight: '5px' }} /> {formatNumber(post.engagement?.like_count ?? 0)}</td>
                                    <td><img src={CommentsSvg} style={{ width: '18px', height: '18px', marginRight: '5px' }} />{formatNumber(post.engagement?.comment_count ?? 0)}</td>
                                    <td> <img src={ViewsSvg} style={{ width: '18px', height: '18px', marginRight: '5px' }} />{formatNumber(post.engagement?.view_count ?? 0)}</td>
                                    <td>{calculateEngagementRate(post)}</td>
                                </tr>
                            ))}

                        </MDBTableBody>
                    </MDBTable>
                </main>
            </div>
        </div>
    );
};

export default CampaignDetails;